<template>
  <div>
    <div style="color: #727273;margin-top:20px;text-align: center">
      <!-- <i class="el-icon-office-building"></i><span style="margin-left: 10px">{{com.comfullname}}({{com.comtypename}})</span> -->
      <!--<i style="margin-left: 20px"></i><span style="margin-left: 10px">{{com.comtypename}}</span>-->
      <!-- <i class="el-icon-user" style="margin-left: 20px"></i><span style="margin-left: 10px">{{com.username}}</span> -->
      <span>欢迎{{$store.getters.expertLoginUser.pexpertname}}评审人评审项目</span>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import request from '@/utils/request'
  export default {
    name: 'vgfooter',
    data () {
      return {
      }
    },
    computed: {
    },
    created () {
    },
    watch: {
    },
    methods: {
    }
  }
</script>
<style>

</style>
